<div>
  <!-- <ck-editor #ckEditor="ckEditor" [(ngModel)]="value" (change)="onChange($event)" [config]="config" (ready)="ckeditorReady($event)"></ck-editor> -->
  <!-- <ckeditor #ckEditor id="ckEditor" [editor]="Editor" [data]="value" [config]="config" (ready)="onReady($event)"
    (change)="onChange($event)">
  </ckeditor> -->
</div>